export class AuthInstance {
    constructor(username, password, url, hash, tenantId, connectString, isPaired, token) {
        this.token = null;
        this.username = username;
        this.password = password;
        this.url = url;
        this.hash = hash;
        this.tenantId = tenantId;
        this.connectString = connectString;
        this.isPaired = isPaired;
        this.token = token;
    }
    pair() {
        this.isPaired = true;
    }
    setToken(token) {
        this.token = token;
    }
    isSameAs(other) {
        if (other === null)
            return false;
        return (this.username === other.username &&
            this.password === other.password &&
            this.url === other.url &&
            this.hash === other.hash &&
            this.tenantId === other.tenantId &&
            this.connectString === other.connectString &&
            this.isPaired === other.isPaired &&
            this.token === other.token);
    }
    toLogObject() {
        return {
            url: this.url,
            hash: this.hash,
            tenantId: this.tenantId,
            connectString: this.connectString,
            isPaired: this.isPaired,
            tokenSet: !!this.token,
        };
    }
}
//# sourceMappingURL=AuthInstance.js.map